export default {
      id: "unknown-usage",
      viewBox: "0 0 32 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#unknown",
      toString: function () {
        return this.url;
      }
    }